import React, {Component} from 'react';
import axios from 'axios';
import './OTPCheck.css';
class OTPCheck extends React.Component {

constructor(){
    super();
}
 

  render() {
    return <div>

                <div className="row  ">


                  <div className="   pt-5 pb-5 center-space">
                    <div className="text-center">
                      <a className="" href=""> <img src="/assets/images/logo/logo.jpg" alt="" title="" className="img-fluid" /> </a>
                    </div>
                            <div class="row-form  mt-5 center-space pl-1 bottom-space-long my-otp">
                                        <h6 class="green-label">Enter OTP</h6>
                                        <input class="form-controls " type="text" placeholder="" id="example-email-input" maxLength="4"/>
                                        <p class={this.props.msgClass}>{this.props.msg}</p>

                                        <a href="#" className="sub-tag">Change Mobile Number</a> <br></br>
                                        <a href="#" className="sub-tag">Resend OTP</a>
                                        </div> 
                                        <div className="text-center ">
                                              <button type="button" class=" add-to-cart2 btnn ">Save</button><br/>
                                              <button type="button" class="  btnn  btn-outline-green">Cancel</button></div>
                                        </div>
                </div>
    </div>
    }
}

export default OTPCheck;
